import { useQuery } from '@tanstack/react-query';
import { VehicleApi } from 'api';

export function useGetVehicleDetail(id) {
  return useQuery({
    queryKey: ['vehicle-detail', id],
    queryFn: () => VehicleApi.getDetail(id).then((res) => res.data),
  });
}
